import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { LegalFeatureConfig } from '../../../types/insurances/LegalFeatureConfig';
import { legal as base } from './base';
import { legal as AT } from './AT';

export const legalConfig: InsuranceIndex<LegalFeatureConfig> = { base, AT };
